<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('marketing.salesTools') }}</span>
        <h3 class="page-title">{{ $t('marketing.emailMessages') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success" @click.prevent="$router.push('/funkcje-sprzedazowe/wiadomosci-email/nowy')">
          <i class="material-icons">add</i>
          {{ $t('marketing.addNewMessage') }}
        </d-button>
      </d-col>
    </d-row>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
    </d-alert>
    <d-card
      v-else
      style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <!-- TODO: zweryfikować nagłówki kolumn -->
            <th scope="col" class="border-0">{{ $t('ui.name') }}</th>
            <th scope="col" class="border-0 text-center">{{ $t('marketing.subject') }}</th>
            <th scope="col" class="border-0 text-center">{{ $t('marketing.updatedAt') }}</th>
            <th scope="col" class="border-0 text-center">{{ $t('status.status') }}</th>
            <th scope="col" class="border-0 text-right">{{ $t('marketing.emailsCount') }}</th>
            <th scope="col" class="border-0 text-right">{{ $t('marketing.segmentsCount') }}</th>
            <th scope="col" class="border-0 text-center" width="125">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(item, index) of mailings"
            :key="'mailing-' + index">
            <td class="align-middle">
              {{ item.name }}
            </td>
            <td class="align-middle text-center">
              {{ item.subject }}
            </td>
            <td class="align-middle text-center">
              {{ formatDate(item.updated_at) }}
            </td>
            <td class="align-middle text-center">
              <mailing-status-badge :status="item.status" />
            </td>
            <td class="align-middle text-right">
              {{ item.emails_count }}
            </td>
            <td class="align-middle text-right">
              {{ item.segments_count }}
            </td>
            <td class="align-middle text-center">
              <d-button
                theme="primary"
                @click.native="$router.push('/funkcje-sprzedazowe/wiadomosci-email/edycja/' + item.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeMailing(item.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="mailings.length === 0">
            <td
              colspan="5"
              class="text-center">
              {{ $t('marketing.noMessagesToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import CalendarUtils from '@/utils/CalendarUtils';
import MailingStatusBadge from '@/components/marketing/mailings/MailingStatusBadge.vue';

export default {
  name: 'marketing-mailings',
  components: {
    'mailing-status-badge': MailingStatusBadge
  },
  data () {
    return {
      mailings: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/marketing/mailings/items', 'mailings', {}, 'get');
    },
    formatDate (date) {
      if (!date) {
        return '-'
      }

      return CalendarUtils.formatDateForPHP(new Date(date));
    },
    removeMailing (countryID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/marketing/mailings/delete/',
        id: countryID,
        successTitle: this.$t('marketing.removeMailingSuccessTitle'),
        successText: this.$t('marketing.removeMailingSuccessText'),
        confirmTitle: this.$t('marketing.removeMailingConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('marketing.removeMailingErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

